/**
 * Standalone subscription modal for sections/subscription-popup.liquid
 */
(function () {
  function storageGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, val) {
    try {
      window.localStorage.setItem(key, val);
    } catch (e) {}
  }

  function parseHours(freq) {
    var n = parseFloat(freq, 10);
    return isNaN(n) ? 0 : n;
  }

  function canShowByFrequency(root) {
    var hours = parseHours(root.dataset.hourFrequency || '0');
    if (hours <= 0) return true;
    var raw = storageGet(root.dataset.storageShown);
    if (!raw) return true;
    var prev = new Date(raw);
    if (isNaN(prev.getTime())) return true;
    var diff = (Date.now() - prev.getTime()) / 1000 / 60 / 60;
    return diff >= hours;
  }

  function shouldSkipPage(root) {
    var path = root.dataset.targetPage || '';
    if (!path || root.dataset.showOnSpecificPage !== 'true') return false;
    var current = window.location.pathname;
    return path !== current;
  }

  /** After Shopify redirects (e.g. ?customer_posted=true), show thank-you inside this dialog */
  function isThisSubscriptionPostReturn(root) {
    if (root.querySelector('.form-status__message--success')) return true;
    try {
      if (new URLSearchParams(window.location.search).get('customer_posted') !== 'true') return false;
    } catch (e) {
      return false;
    }
    var id = root.dataset.sectionId || '';
    var h = window.location.hash || '';
    if (id && h.indexOf('subposted-' + id) !== -1) return true;
    if (h.indexOf('subscription_popup') !== -1 || h.indexOf('subscription-popup') !== -1) return true;
    return false;
  }

  function stripCustomerPostedFromUrl() {
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('customer_posted') !== 'true') return;
      u.searchParams.delete('customer_posted');
      var next = u.pathname + (u.search ? u.search : '') + (u.hash || '');
      window.history.replaceState({}, document.title, next);
    } catch (e) {}
  }

  function lockScroll() {
    document.documentElement.classList.add('subscription-popup--scroll-locked');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('subscription-popup--scroll-locked');
  }

  function openDialog(dialog) {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    lockScroll();
  }

  function closeDialog(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    unlockScroll();
  }

  function bind(root) {
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    if (root.dataset.enabled !== 'true' && !designMode) return;

    if (!designMode) {
      if (shouldSkipPage(root)) return;
      if (root.dataset.disableForAccounts === 'true' && root.dataset.customerLoggedIn === 'true') {
        return;
      }
      var postedReturn = isThisSubscriptionPostReturn(root);
      if (storageGet(root.dataset.storageSubmit) && !postedReturn) return;
      if (storageGet(root.dataset.storageDismiss) && !postedReturn) return;
      if (!postedReturn && !canShowByFrequency(root)) return;
    }

    var dialog = root.querySelector('.subscription-popup__dialog');
    if (!dialog) return;

    if (root.dataset.subscriptionBound === '1') return;
    root.dataset.subscriptionBound = '1';

    var hasOpened = false;

    function markShown() {
      storageSet(root.dataset.storageShown, new Date().toISOString());
    }

    function onDismiss() {
      storageSet(root.dataset.storageDismiss, '1');
      stripCustomerPostedFromUrl();
      closeDialog(dialog);
    }

    function wireClose() {
      root.querySelectorAll('[data-subscription-popup-dismiss]').forEach(function (btn) {
        btn.addEventListener('click', onDismiss);
      });
    }

    wireClose();

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) onDismiss();
    });

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      onDismiss();
    });

    var form = root.querySelector('.js-subscription-popup-form');
    if (form) {
      form.addEventListener('submit', function () {
        storageSet(root.dataset.storageSubmit, '1');
      });
    }

    function tryOpen() {
      if (hasOpened) return;
      hasOpened = true;
      var hours = parseHours(root.dataset.hourFrequency || '0');
      if (hours > 0) {
        markShown();
      }
      openDialog(dialog);
    }

    var delayType = root.dataset.delayType || 'timer';
    var delayVal = parseInt(root.dataset.delayValue || '0', 10);

    if (designMode) {
      var sectionId = String(root.dataset.sectionId);

      function setEditorActive(active) {
        if (active) {
          root.classList.add('subscription-popup--editor-active');
        } else {
          root.classList.remove('subscription-popup--editor-active');
        }
      }

      function openEditorPreview() {
        setEditorActive(true);
        openDialog(dialog);
      }

      function closeEditorPreview() {
        setEditorActive(false);
        closeDialog(dialog);
      }

      function isThisSection(ev) {
        return ev.detail && String(ev.detail.sectionId) === sectionId;
      }

      document.addEventListener('shopify:section:select', function (ev) {
        if (isThisSection(ev)) openEditorPreview();
      });
      document.addEventListener('shopify:section:deselect', function (ev) {
        if (isThisSection(ev)) closeEditorPreview();
      });
      document.addEventListener('shopify:section:load', function (ev) {
        if (isThisSection(ev)) openEditorPreview();
      });
      document.addEventListener('shopify:section:unload', function (ev) {
        if (isThisSection(ev)) closeEditorPreview();
      });
      document.addEventListener('shopify:section:reorder', function () {
        closeEditorPreview();
      });

      return;
    }

    if (!designMode && isThisSubscriptionPostReturn(root)) {
      tryOpen();
      var okMsg = root.querySelector('.form-status__message--success');
      if (okMsg && typeof okMsg.focus === 'function') {
        setTimeout(function () {
          okMsg.focus();
        }, 200);
      }
      return;
    }

    if (delayType === 'timer') {
      setTimeout(tryOpen, delayVal);
    } else if (delayType === 'scroll') {
      var pct = Math.min(100, Math.max(0, delayVal)) / 100;
      function onScroll() {
        var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        if (maxScroll <= 0) {
          tryOpen();
          window.removeEventListener('scroll', onScroll);
          return;
        }
        if (window.scrollY >= maxScroll * pct) {
          tryOpen();
          window.removeEventListener('scroll', onScroll);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('load', onScroll);
    }

    if (root.dataset.exitIntent === 'true' && delayType !== 'scroll') {
      var mobile =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (!mobile) {
        document.body.addEventListener(
          'mouseout',
          function leave(ev) {
            if (!ev.relatedTarget && !ev.toElement) {
              document.body.removeEventListener('mouseout', leave);
              tryOpen();
            }
          },
          { passive: true }
        );
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-subscription-popup-root]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
